module.exports = __webpack_public_path__ + "static/media/two-third.42d61653.svg";